<!--
 * @Author: Shen Kui
 * @LastEditTime: 2023-10-25 10:00:11
 * @Description:
 * @LastEditors: wangliang wangliang@wiz.top
-->
<template>
  <div class="w-full h-full px-10px text-14px text-white">
    <div class="w-full text-14px mt-10px">
      <ul>
        <li class="flex mb-12px truncate" v-for="k in basicDescInfo" :key="k.filedName">
          <span class="w-115px text-right pr-8px text-hex-ffffff">{{ k.name }}</span
          ><span class="flex-1 text-left">{{ k.desc }}</span>
        </li>
      </ul>
    </div>
    <div class="w-full h-250px mt-20px">
      <div class="flex items-center">
        <img class="w-19px h-26px" src="../../assets/images/titleIcon.png" alt="" />
        <span class="pl-6px text-white text-16px">围栏报警规则</span>
      </div>
      <ul class="w-full h-[calc(100%-26px)]">
        <li class="h-36px w-full flex items-center pl-22px pr-8px list--bg__linear">
          <span class="truncate" :class="k.width" v-for="k in ruleInfo.title" :key="k.filedName">{{
            k.desc
          }}</span>
        </li>
        <li
          class="h-36px flex  pl-22px pr-8px  items-center "
          v-for="k in ruleInfo.data"
          :key="k.id"
        >
          <template v-for="(v, vIndex) in ruleInfo.title">
            <el-tooltip
              :key="k.id + vIndex"
              effect="dark"
              :open-delay="400"
              :content="k[v.filedName]"
              placement="top-start"
              ><span class="truncate" :class="v.width">{{ k[v.filedName] }}</span>
            </el-tooltip></template
          >
        </li>
        <li
          v-if="!ruleInfo.data.length"
          class="w-full h-[calc(100%-34px)] flex flex-1 items-center justify-center tex-16px"
        >
          暂无数据
        </li>
      </ul>
    </div>
    <div class="w-full h-280px my-20px">
      <div class="flex items-center">
        <img class="w-19px h-26px" src="../../assets/images/titleIcon.png" alt="" />
        <span class="pl-6px text-white text-16px">围栏报警记录</span>
      </div>
      <ul class="w-full h-[calc(100%-26px)]">
        <li class="h-36px w-full flex items-center pl-22px pr-8px list--bg__linear">
          <span
            class="truncate"
            :class="k.width"
            v-for="k in recordInfo.title"
            :key="k.filedName"
            >{{ k.desc }}</span
          >
        </li>
        <li
          class="h-36px flex pl-22px pr-8px  items-center "
          v-for="k in recordInfo.data"
          :key="k.id"
        >
          <template v-for="(v, vIndex) in recordInfo.title">
            <el-tooltip
              :key="k.id + vIndex"
              effect="dark"
              :open-delay="400"
              :content="k[v.filedName]"
              placement="top-start"
              ><span class="truncate" :class="v.width">{{ k[v.filedName] }}</span>
            </el-tooltip></template
          >
        </li>
        <li
          v-if="!recordInfo.data.length"
          class="w-full h-[calc(100%-34px)] flex flex-1 items-center justify-center tex-16px"
        >
          暂无数据
        </li>
      </ul>
    </div>
    <el-pagination
      class="float-right transform !translate-x-20px pr-6px visualization__page--theme"
      background
      small
      @size-change="gethandledList"
      @current-change="gethandledList"
      :current-page.sync="handledPage.pageNo"
      layout="slot, prev, pager, next"
      :page-size.sync="handledPage.pageSize"
      :total="handledPage.total"
    >
      <template>
        <div class="inline-block h-24px leading-24px">
          共<span class="!leading-24px text-center text-hex-fbaf3d">{{ handledPage.total }}</span
          >条数据
        </div>
      </template>
    </el-pagination>
  </div>
</template>

<script>
import { cloneDeep, get, map, forEach, isNumber, eq } from 'lodash'
import {
  StandardFenceApi,
  StandardAlarmRecordApi,
  StandardAlarmSettingApi,
} from '@wiz-api/personnel-position'

const fenceApi = new StandardFenceApi()
const alarmRecordApi = new StandardAlarmRecordApi()
const alarmSettingApi = new StandardAlarmSettingApi()

export default {
  name: 'electronicFenceInfo',
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      basicDescInfo: [
        { name: '围栏名称：', filedName: 'fenceName', desc: '' },
        { name: '围栏高度：', filedName: 'height', desc: '' },
        { name: '关联报警数量：', filedName: 'alarmSetCount', desc: '' },
      ], // 电子围栏详情配置
      ruleInfo: {
        title: [
          { width: 'w-1/2', desc: '报警规则', filedName: 'alarmTypeName' },
          { width: 'w-1/2', desc: '报警对象', filedName: 'personNames' },
        ],
        data: [],
      }, // 电子围栏规则配置
      recordInfo: {
        title: [
          { width: 'w-3/10', desc: '报警类型', filedName: 'alarmTypeName' },
          { width: 'w-3/10', desc: '报警对象', filedName: 'personNames' },
          { width: 'w-4/10', desc: '报警时间', filedName: 'eventStartTime' },
        ],
        data: [],
      }, // 电子围栏报警记录配置
      handledPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      }, // 电子围栏记录分页
    }
  },
  computed: {
    fenceId() {
      return get(this.transferProps, 'fenceId')
    },
  },
  watch: {
    fenceId: {
      handler(newFenceId, oldFenceId) {
        if (eq(newFenceId, oldFenceId)) {
          return
        }
        this.initCompData()
      },
      deep: true,
    },
  },
  created() {
    this.initCompData()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 初始化数据
    initCompData() {
      this.getFenceDetail()
      this.gethandledList()
      this.getAlarmList()
    },
    // 获取电子围栏详情
    async getFenceDetail() {
      const [err, res] = await fenceApi.get(this.fenceId)
      if (!err && res) {
        const tempFenceDetail = cloneDeep(this.basicDescInfo)
        forEach(tempFenceDetail, (item) => {
          const desc = get(res, get(item, 'filedName'))
          item.desc = desc || isNumber(desc) ? desc : '--'
        })
        this.basicDescInfo = tempFenceDetail
      }
    },
    // 获取电子围栏规则
    async getAlarmList() {
      const [err, res] = await alarmSettingApi.getList({
        standardFenceId: this.fenceId,
        dataSource: 1,
        maxResultCount: 999,
        skipCount: 0,
      })
      if (!err && res) {
        this.ruleInfo.data = res.items
      }
    },
    // 获取电子围栏记录
    async gethandledList() {
      const [err, res] = await alarmRecordApi.getList({
        standardFenceId: this.fenceId,
        handleState: 0,
        maxResultCount: this.handledPage.pageSize,
        skipCount: (this.handledPage.pageNo - 1) * this.handledPage.pageSize,
      })
      if (!err && res) {
        this.recordInfo.data = map(res.items, (item) => {
          return {
            ...item,
            eventStartTime: moment(item.eventStartTime).format('YYYY-MM-DD HH:mm:ss'),
            name: item.personNames + item.alarmTypeName + item.fenceName,
          }
        })
        this.handledPage.total = res.totalCount
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.list--bg__linear {
  background:var(--tableHeadBg);
  background-size: 100% 100%;
}

.visualization__page--theme {
  --inputBg: transparent;
  --titleTextColor: #fff;
  --systemMainColor: #02cfe4;
  --paginationButtonBg: transparent;
  --contentTextColor: #fff;
  ::v-deep {
    button[class^='btn-'] {
      width: 24px;
      height: 24px;
    }

    .btn-prev,
    .btn-next {
      background-color: #345479;
      color: #fff;
    }

    .el-pager {
      li {
        min-width: 24px !important;
        height: 24px;
        margin: 0 3px 0 3px !important;
        line-height: 24px;
        border-radius: 3px;
        border: 1px solid rgba(141, 194, 255, 0.28);
      }
    }
  }
}
</style>
